import React from 'react';

function Icon({classes, icon}) {
    return (
        <figure className={`icon-ue ${classes}`}>
            <img src={icon} alt="icon" />
        </figure>
    );
}

export default Icon;